import { render, staticRenderFns } from "./DocumentPageWrapper.vue?vue&type=template&id=6fec2afa&scoped=true&lang=html"
import script from "./DocumentPageWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentPageWrapper.vue?vue&type=script&lang=js"
import style0 from "./DocumentPageWrapper.vue?vue&type=style&index=0&id=6fec2afa&prod&lang=scss"
import style1 from "./DocumentPageWrapper.vue?vue&type=style&index=1&id=6fec2afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../modules/rajalex/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec2afa",
  null
  
)

export default component.exports